import { motion } from 'framer-motion';

export default function Button({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  fullWidth = false,
  disabled = false,
  className = ''
}) {
  const baseStyles = 'px-8 py-4 rounded-button font-semibold text-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed';

  const variantStyles = {
    primary: 'bg-renuvia-gold text-white hover:bg-opacity-90 shadow-lg hover:shadow-luxury-hover',
    secondary: 'bg-white text-charcoal border-2 border-charcoal hover:bg-gray-50',
    outline: 'bg-transparent text-renuvia-gold border-2 border-renuvia-gold hover:bg-renuvia-gold hover:text-white',
    green: 'bg-onyx-green text-white hover:bg-opacity-90 shadow-lg hover:shadow-luxury-hover',
    ghost: 'bg-transparent text-gray-500 border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 flex items-center justify-center'
  };

  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${widthClass} ${className}`}
      whileHover={{ scale: disabled ? 1 : 1.02 }}
      whileTap={{ scale: disabled ? 1 : 0.98 }}
    >
      {children}
    </motion.button>
  );
}
